import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getEmployeesLastLocationList,
  getEmployeeTrackingHistory,
} from '../services';
import {
  RoleType,
  SelectOptionType,
  TrackLocationInitialState,
} from '../utils/Types';
import { isAPISuccess } from '../utils/Util';
import { getAllRolesDrops, getRoles } from '../services/dropDownService';

const initialState: TrackLocationInitialState = {
  lastLocationList: [],
  locationListError: null,
  roleOptions: [],
  trackHistoryList: [],
  trackMarkerList: [],
  statusCount: {
    totalUsers: 0,
    userCount: 0,
  },
  allRoleOptions: [],
};

export const getLastLocationList = createAsyncThunk(
  'trackLocation/LastLocation',
  async (data: any) => {
    const res = await getEmployeesLastLocationList(data);
    return res?.data;
  }
);
export const getTrackingHistory = createAsyncThunk(
  'trackLocation/getTrackingHistory',
  async (params: any) => {
    const res = await getEmployeeTrackingHistory(params);
    return res.data;
  }
);
export const getRollDrops = createAsyncThunk(
  'trackLocation/getRoles',
  async () => {
    const res = await getRoles({});
    return res.data;
  }
);
export const getAllRoles = createAsyncThunk(
  'trackLocation/getAllRoles',
  async () => {
    const res = await getAllRolesDrops({});
    return res.data;
  }
);
const onGetLocationListError = (state: any, action: any) => {
  state.lastLocationList = [];
  state.statusCount = {
    totalUsers: 0,
    userCount: 0,
  };
  state.locationListError =
    action.payload?.responseInformation?.responseMessage;
};
export const trackLocationSlice = createSlice({
  name: 'trackLocation',
  initialState,
  reducers: {
    clearTrackHistoryList: (state) => {
      state.trackHistoryList = [];
      state.trackMarkerList = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getLastLocationList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.lastLocationList = action.payload.result.list;
          state.statusCount = {
            totalUsers: action.payload.result?.totalUsers ?? 0,
            userCount: action.payload.result?.userCount ?? 0,
          };
          if (
            action.payload.result.list &&
            action.payload.result.list.length > 0
          ) {
            state.locationListError = null;
          } else if (
            (action.payload.result?.totalUsers ?? 0) > 0 &&
            (action.payload.result?.userCount ?? 0) === 0
          ) {
            state.locationListError =
              'Unable to track the location of this employee';
          } else {
            state.locationListError = 'No employee found';
            state.statusCount = {
              totalUsers: action.payload.result?.totalUsers ?? 0,
              userCount: action.payload.result?.userCount ?? 0,
            };
          }
        } else {
          onGetLocationListError(state, action);
        }
      })
      .addCase(getLastLocationList.rejected, (state, action: any) => {
        onGetLocationListError(state, action);
      })
      .addCase(getRollDrops.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload) && action.payload.result) {
          const roles: SelectOptionType[] = [];
          action.payload.result.forEach((item: RoleType) => {
            roles.push({ value: item.roleId, label: item.roleName });
          });
          state.roleOptions = roles;
        } else {
          state.roleOptions = [];
        }
      })
      .addCase(getAllRoles.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload) && action.payload.result) {
          const roles: SelectOptionType[] = [];
          action.payload.result.forEach((item: RoleType) => {
            roles.push({ value: item.roleId, label: item.roleName });
          });
          state.allRoleOptions = roles;
        } else {
          state.allRoleOptions = [];
        }
      })
      .addCase(getTrackingHistory.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload) && action.payload.result) {
          state.trackHistoryList = action.payload.result?.[0]?.routes || [];
          state.trackMarkerList = action.payload.result?.[0]?.markers || [];
        } else {
          state.trackHistoryList = [];
          state.trackMarkerList = [];
        }
      })
      .addCase(getTrackingHistory.rejected, (state) => {
        state.trackHistoryList = [];
        state.trackMarkerList = [];
      });
  },
});
export const trackLocationSelector = (state: {
  trackLocation: TrackLocationInitialState;
}) => state.trackLocation;
export const { clearTrackHistoryList } = trackLocationSlice.actions;
export default trackLocationSlice.reducer;
